export const queryKeys = {
  scenarios: ["scenarios"] as const,
  progress: ["progress"] as const,
  stats: ["stats"] as const,
  leaderboard: ["leaderboard"] as const,
  achievements: ["achievements"] as const,
  dailyChallenge: ["dailyChallenge"] as const,
  challenges: ["challenges"] as const,
  weeklyLeague: ["weeklyLeague"] as const,
};
